<template>
  <div class="p-contentplans-writing-ai-phase">
    <Advice img="pencil" priority="low-gray">
      <p>
        AIを利用してコンテンツ構成案の設計をお手伝いします。<br />
        <strong
          >AIを利用しているため、いつも完璧なものを提案できるわけではありません。<br />
          あくまでも参考程度に留めて、最終的にはご自身で必ず修正してください。</strong
        >
      </p>
    </Advice>
    <Advice v-if="isLoading" img="pencil" priority="low-gray">
      <p>検索意図を考えています<span class="c-loading-dots"></span></p>
    </Advice>
    <template v-else>
      <Advice img="pencil" priority="low-gray">
        <p v-if="isError">
          調査したキーワードはChat
          API(GPT-3.5)のポリシーに反する内容だったため、AIからの回答を受け取れませんでした。
        </p>
        <div v-else class="c-text--free">
          <p>以下のような検索意図が考えられます。</p>
          <ol class="c-list--decimal">
            <li v-for="item in aiKeywordIntentData.items" :key="item">
              {{ item }}
            </li>
          </ol>
        </div>
      </Advice>
    </template>
  </div>
</template>

<script>
import Advice from '@/components/Advice';

export default {
  props: {
    aiKeywordIntentData: {
      type: Object,
      required: false,
      default: null
    },
    error: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Advice
  },
  data() {
    return {
      selected: this.userSelectedKeywordIntent
    };
  },
  computed: {
    isError() {
      // dataがnull、またはitemsが空の場合はtrue
      return !this.aiKeywordIntentData ||
        !this.aiKeywordIntentData.items ||
        !this.aiKeywordIntentData.items.length
        ? true
        : false;
    }
  }
};
</script>
